import React from 'react'
import { string } from 'prop-types'
import styled, { withTheme } from 'styled-components'
import { Box } from 'rebass'
import { media } from '../../utils/style'
import buildImageUrl from '../../../lib/media-url-maker'

const Fullwidth = styled(Box)`
  padding-bottom: 56.25%;
  width: 100%;
  height: 100%;
  position: relative;
  iframe {
    position: absolute;
    z-index: 2;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`

const VideoFrame = withTheme(styled.div`
  height: 100%;
  width: 100%;
  margin: auto;
  max-width: ${(props) => props.theme.content.max.width};
  div {
    opacity: 1;
    transition: opacity 0.3s ${(props) => props.theme.ease.ease_out_expo} 0.2s;
  }
  .hide {
    opacity: 0;
    pointer-events: none;
  }
`)

const Shadow = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  height: 100%;
  width: 100%;
  z-index: 1;
  ${media.LargeScreenUp`
  &::before {
    content:'';
    position: absolute;
    z-index: 0;
    bottom: 5px;
    width: 95%;
    height: 100%;
    box-shadow:
      0 35px 35px 0px rgba(66, 76, 94, 0.07),
      0 20px 20px 0 rgba(0, 0, 0, 0.02);
  }
  `};
`

class ContentVideoPlayer extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      active: 'show'
    }
    this.imgSrc = this.props.img
      ? buildImageUrl({ resource: this.props.img })
      : `https://img.youtube.com/vi/${this.props.id}/maxresdefault.jpg`
  }

  render() {
    return (
      <VideoFrame>
        <Fullwidth>
          <iframe
            src={`https://www.youtube-nocookie.com/embed/${this.props.id}?autoplay=0&rel=0&showinfo=0&controls=0&modestbranding=1&enablejsapi=1`}
            frameBorder="0"
            allow="autoplay; encrypted-media"
            allowFullScreen
            width="100%"
            height="100%"
            title={this.props.text}
          />
          <Shadow />
        </Fullwidth>
      </VideoFrame>
    )
  }
}

ContentVideoPlayer.defaultProps = {
  id: 'mCAcnmhxTN8'
}
ContentVideoPlayer.propTypes = {
  img: string,
  id: string,
  text: string
}

export default ContentVideoPlayer
